module.exports = __webpack_public_path__ + "img/wolf_900.6cb7131c.png";